import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    makeStyles,
    MenuItem,
    Popover,
    Select,
    Tab,
    Tabs,
    TextField,
    Typography,
} from "@material-ui/core"
import { AddAPhoto, DeleteForever, InfoOutlined } from "@material-ui/icons"
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab"
import { useSnackbar } from "../../../utils/notificacoes"
import { useEffect, useRef, useState } from "react"
import { redimensionarImagemProduto } from "../../../functions/imagens"
import useAppStore from "../../../stores/AppStore"
import DialogEscolherOrigemFoto from "./DialogEscolherOrigemFoto"
import DialogGaleriaFotos from "./DialogGaleriaFotos"
import CanaisVenda, { canaisDoBackend, canaisParaBackend } from "./CanaisVenda"

const useStyles = makeStyles(theme => ({
    titulo: {
        backgroundColor: "white",
        "& .MuiTypography-root": {
            fontWeight: 600,
            color: "#2c3e50",
        },
    },
    container: {
        backgroundColor: "white",
        overflowY: "hidden",
        "& .MuiOutlinedInput-root": {
            borderRadius: 12,
            "& fieldset": { borderColor: "#e0e0e0" },
            "&:hover fieldset": { borderColor: "#4caf50" },
            "&.Mui-focused fieldset": { borderColor: "#4caf50" },
        },
    },
    containerImg: {
        margin: "auto",
        width: "200px",
        height: "200px",
        backgroundColor: "#fafafa",
        border: "2px dashed #ccc",
        borderRadius: 12,
        cursor: "pointer",
        transition: "all 0.2s ease",
        "&:hover": {
            borderColor: "#4caf50",
            backgroundColor: "#f8fff8",
        },
    },
    addAPhoto: {
        width: "30%",
        height: "30%",
        color: "rgba(0,0,0,0.5)",
    },
    textoImg: {
        color: "rgba(0,0,0,0.5)",
    },
    input: {
        display: "none",
    },
    botoes: {
        backgroundColor: "white",
    },
    botaoExcluir: {
        borderRadius: 25,
        textTransform: "none",
        fontWeight: 600,
        padding: "8px 22px",
        transition: "all 0.2s ease",
        backgroundColor: "var(--cor-erro)",
        color: "white",
        boxShadow: "0 4px 15px rgba(244,67,54,0.3)",
        "&:hover": {
            backgroundColor: "var(--cor-erro-hover)",
            transform: "translateY(-2px)",
            boxShadow: "0 6px 20px rgba(244,67,54,0.4)",
        },
    },
    botaoVoltar: {
        borderRadius: 25,
        textTransform: "none",
        fontWeight: 600,
        padding: "8px 22px",
        transition: "all 0.2s ease",
        color: "#546e7a",
        border: "1.5px solid #cfd8dc",
        backgroundColor: "transparent",
        "&:hover": {
            backgroundColor: "rgba(84,110,122,0.08)",
        },
    },
    botaoSalvar: {
        borderRadius: 25,
        textTransform: "none",
        fontWeight: 600,
        padding: "8px 22px",
        transition: "all 0.2s ease",
        backgroundColor: "var(--cor-botao-salvar)",
        color: "white",
        boxShadow: "0 4px 15px rgba(var(--cor-botao-salvar-rgb),0.3)",
        "&:hover": {
            backgroundColor: "var(--cor-botao-salvar-hover)",
            transform: "translateY(-2px)",
            boxShadow: "0 6px 20px rgba(var(--cor-botao-salvar-rgb),0.4)",
        },
    },
    toggleButton: {
        backgroundColor: "rgba(0,0,0,0.1)",
        color: "rgba(255,0,0,0.5)",

        "&.Mui-selected": {
            backgroundColor: "#28a745",
            color: "white",
        },

        "&:hover": {
            backgroundColor: "#3CB371",
        },
    },
}))

export default function DialogProdutos({
    open,
    modalProduto,
    cadastrar,
    handleCloseProduto,
    handleSalvarProduto,
    categorias,
    categoriaAtual,
    handleCadastrarImagem,
    estabelecimento,

    insumos,
    insumoSelecionado,
    insumosSelecionados,
    fichaTecnica,
    quantidades,
    handleAddInsumo,
    handleDeleteInsumo,
    salvarFt,
    setInsumoSelecionado,
    setQuantidades,
    setAltInsumo,
    produto,
}) {
    const configs = useAppStore(s => s.configuracoes)
    const paramentos = configs.user.parametros
    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    function encontrarCategoriaIdPorProduto() {
        const categoria = categorias?.find(categoria =>
            categoria?.produtos?.some(produto => produto?.id === modalProduto?.id)
        )
        return categoria ? categoria?.id : null
    }

    const fileInputRef = useRef(null)
    const handleDivClick = () => {
        fileInputRef.current.click()
    }
    const [imagem, setImagem] = useState("")
    const [galeriaAberta, setGaleriaAberta] = useState(false)
    const [escolhaAberta, setEscolhaAberta] = useState(false)

    const handleFileChange = async event => {
        const file = event.target.files[0]
        if (!file) return

        try {
            const arquivoRedimensionado = await redimensionarImagemProduto(file)
            const nomeArquivo = file.name
            const idProduto = null
            const idOpcao = null
            const idPasso = null

            const response = await handleCadastrarImagem(
                nomeArquivo,
                idProduto,
                idPasso,
                idOpcao,
                arquivoRedimensionado
            )

            setImagem(response)
        } catch (error) {
            alertStart(`${error}`, "error")
        }
    }

    const [tela, setTela] = useState("Geral")
    const [salvando, setSalvando] = useState(false)

    const id = modalProduto?.id
    const versao = modalProduto?.versao
    const nomeRef = useRef(modalProduto?.nome)
    const valorRef = useRef(modalProduto?.valor)
    const codigoRef = useRef(modalProduto?.codigo)

    const proximaOrdemExib = cadastrar
        ? Math.max(0, ...(categoriaAtual?.produtos?.map(p => Number(p.ordemExib) || 0) ?? [])) + 1
        : (modalProduto?.ordemExib ?? 0)

    const ordemExibRef = useRef(proximaOrdemExib)

    const [idCategoria, setIdCategoria] = useState()
    const handleChangeIdCategoria = e => setIdCategoria(e.target.value)
    const [impressaoAlternada, setImpressaoAlternada] = useState()
    const handleImpressaoAlternada = e => setImpressaoAlternada(e.target.value)
    const [tipoProducao, setTipoProducao] = useState()
    const [canais, setCanais] = useState(canaisDoBackend(null))
    // "AUTO" é sentinela de UI (Select não pode ter valor vazio, senão a label
    // "CFOP" fica em cima do texto). Persiste null.
    const handleTipoProducao = e =>
        setTipoProducao(e.target.value === "AUTO" ? null : e.target.value)
    const [anchorRecomendacaoCfop, setAnchorRecomendacaoCfop] = useState(null)
    const [disponivelDomingo, setDisponivelDomingo] = useState("")
    const handleChangeDisponivelDomingo = () => setDisponivelDomingo(!disponivelDomingo)
    const [disponivelSegunda, setDisponivelSegunda] = useState("")
    const handleChangeDisponivelSegunda = () => setDisponivelSegunda(!disponivelSegunda)
    const [disponivelTerca, setDisponivelTerca] = useState("")
    const handleChangeDisponivelTerca = () => setDisponivelTerca(!disponivelTerca)
    const [disponivelQuarta, setDisponivelQuarta] = useState("")
    const handleChangeDisponivelQuarta = () => setDisponivelQuarta(!disponivelQuarta)
    const [disponivelQuinta, setDisponivelQuinta] = useState("")
    const handleChangeDisponivelQuinta = () => setDisponivelQuinta(!disponivelQuinta)
    const [disponivelSexta, setDisponivelSexta] = useState("")
    const handleChangeDisponivelSexta = () => setDisponivelSexta(!disponivelSexta)
    const [disponivelSabado, setDisponivelSabado] = useState("")
    const handleChangeDisponivelSabado = () => setDisponivelSabado(!disponivelSabado)
    const descricaoRef = useRef(modalProduto?.descricao)

    const ativoRef = useRef(modalProduto?.ativo)
    const permiteObservacaoRef = useRef(modalProduto?.permiteObservacao)

    const valorDomingoRef = useRef(modalProduto?.disponibilidadeProduto?.valorDomingo)
    const valorSegundaRef = useRef(modalProduto?.disponibilidadeProduto?.valorSegunda)
    const valorTercaRef = useRef(modalProduto?.disponibilidadeProduto?.valorTerca)
    const valorQuartaRef = useRef(modalProduto?.disponibilidadeProduto?.valorQuarta)
    const valorQuintaRef = useRef(modalProduto?.disponibilidadeProduto?.valorQuinta)
    const valorSextaRef = useRef(modalProduto?.disponibilidadeProduto?.valorSexta)
    const valorSabadoRef = useRef(modalProduto?.disponibilidadeProduto?.valorSabado)

    const apenasPrimeiraCompraRef = useRef(modalProduto?.apenasPrimeiraCompra)
    const produtoExibicaoRef = useRef(modalProduto?.produtoExibicao)
    const promocionalRef = useRef(modalProduto?.promocional)
    const pontuarProgramaFidelidadeRef = useRef(modalProduto?.pontuarProgramaFidelidade)
    const pontosRef = useRef(modalProduto?.pontos)

    useEffect(() => {
        if (!cadastrar) {
            setImagem(modalProduto?.urlImagem)
            setIdCategoria(encontrarCategoriaIdPorProduto())
            setImpressaoAlternada(modalProduto?.impressaoAlternada)
            setTipoProducao(modalProduto?.tipoProducao)
            setCanais(canaisDoBackend(modalProduto?.canais))
            setDisponivelDomingo(modalProduto?.disponibilidadeProduto?.disponivelDomingo)
            setDisponivelSegunda(modalProduto?.disponibilidadeProduto?.disponivelSegunda)
            setDisponivelTerca(modalProduto?.disponibilidadeProduto?.disponivelTerca)
            setDisponivelQuarta(modalProduto?.disponibilidadeProduto?.disponivelQuarta)
            setDisponivelQuinta(modalProduto?.disponibilidadeProduto?.disponivelQuinta)
            setDisponivelSexta(modalProduto?.disponibilidadeProduto?.disponivelSexta)
            setDisponivelSabado(modalProduto?.disponibilidadeProduto?.disponivelSabado)
        } else {
            setImagem("")
            setIdCategoria(categoriaAtual.id)
            setImpressaoAlternada(0)
            setTipoProducao(null)
            setCanais(canaisDoBackend(null))
            setDisponivelDomingo(true)
            setDisponivelSegunda(true)
            setDisponivelTerca(true)
            setDisponivelQuarta(true)
            setDisponivelQuinta(true)
            setDisponivelSexta(true)
            setDisponivelSabado(true)
        }
    }, [modalProduto, categoriaAtual])

    const classes = useStyles()

    const handleChange = e => {
        valorRef.current.value = e.target.value.replace(".", ",")
    }

    return (
        <>
            {open && (
                <Dialog
                    open={open}
                    onClose={handleCloseProduto}
                    maxWidth="md"
                    fullWidth
                    PaperProps={{ style: { borderRadius: 16 } }}
                >
                    <DialogTitle id="alert-dialog-title" className={classes.titulo}>
                        {cadastrar ? "Cadastrar Produto" : "Editar Produto"}
                    </DialogTitle>
                    <form
                        onSubmit={async e => {
                            e.preventDefault()

                            const nome = nomeRef?.current?.value?.trim()
                            const valorTexto = String(
                                valorRef?.current?.value ?? ""
                            ).trim()
                            const valorNum = parseFloat(valorTexto.replace(",", "."))
                            if (!nome) {
                                alertStart("Informe o nome do produto", "error")
                                return
                            }
                            // Preço é opcional: só valida quando algo foi digitado.
                            if (valorTexto !== "" && isNaN(valorNum)) {
                                alertStart("Informe um preço válido", "error")
                                return
                            }
                            if (!canais.length) {
                                alertStart("Marque ao menos um canal de venda", "error")
                                return
                            }

                            const data = {
                                token: "a~I?;;+_@!AL^",
                                id,
                                versao,

                                urlImagem: imagem,
                                nome,
                                valor: valorTexto === "" ? null : valorNum,
                                codigo: codigoRef?.current?.value,
                                ordemExib: ordemExibRef?.current?.value,
                                descricao: descricaoRef?.current?.value,
                                ativo: ativoRef?.current?.checked,
                                permiteObservacao: permiteObservacaoRef?.current?.checked,
                                tipoProducao,
                                impressaoAlternada,
                                canais: canaisParaBackend(canais),
                                // sem a flag o backend preserva o que está no banco
                                canaisInformado: true,

                                disponibilidadeProduto: {
                                    disponivelDomingo,
                                    disponivelSegunda,
                                    disponivelTerca,
                                    disponivelQuarta,
                                    disponivelQuinta,
                                    disponivelSexta,
                                    disponivelSabado,
                                    valorDomingo: valorDomingoRef?.current?.value,
                                    valorSegunda: valorSegundaRef?.current?.value,
                                    valorTerca: valorTercaRef?.current?.value,
                                    valorQuarta: valorQuartaRef?.current?.value,
                                    valorQuinta: valorQuintaRef?.current?.value,
                                    valorSexta: valorSextaRef?.current?.value,
                                    valorSabado: valorSabadoRef?.current?.value,
                                },

                                apenasPrimeiraCompra: apenasPrimeiraCompraRef?.current?.checked,
                                produtoExibicao: produtoExibicaoRef?.current?.checked,
                                promocional: promocionalRef?.current?.checked,
                                pontuarProgramaFidelidade:
                                    pontuarProgramaFidelidadeRef?.current?.checked,
                                pontos: pontosRef?.current?.value,
                            }

                            setSalvando(true)
                            try {
                                const ok = await handleSalvarProduto(idCategoria, data)
                                // handleSalvarProduto retorna false em erro (mensagem já exibida).
                                // Mantém o modal aberto com os dados preenchidos.
                                if (ok === false) return
                                await salvarFt(id, null)
                                handleCloseProduto()
                            } finally {
                                setSalvando(false)
                            }
                        }}
                    >
                        <DialogContent
                            className={classes.container}
                            style={{ overflowY: "hidden" }}
                        >
                            <Tabs
                                value={tela}
                                onChange={(e, novaTela) => setTela(novaTela)}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="scrollable"
                                scrollButtons="auto"
                            >
                                <Tab value="Geral" label="Geral" />
                                <Tab value="ValorPromocional" label="Valores Promocionais" />
                                <Tab value="Avançado" label="Avançado" />
                            </Tabs>
                            <Divider style={{ marginBottom: 16 }} />
                            <div
                                style={{
                                    display: tela === "Geral" ? "" : "none",
                                    position: "relative",
                                }}
                            >
                                <Grid container direction="row" spacing={2}>
                                    <Grid
                                        className={classes.containerImg}
                                        item
                                        container
                                        justifyContent="center"
                                        alignItems="center"
                                        onClick={() => setEscolhaAberta(true)}
                                    >
                                        {!imagem ? (
                                            <Grid
                                                container
                                                direction="column"
                                                justifyContent="center"
                                                alignItems="center"
                                            >
                                                <AddAPhoto className={classes.addAPhoto} />
                                                <Typography className={classes.textoImg}>
                                                    Selecione uma imagem
                                                </Typography>
                                            </Grid>
                                        ) : (
                                            <img loading="lazy" src={imagem} height="180px" />
                                        )}
                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            onChange={handleFileChange}
                                            className={classes.input}
                                            accept="image/*"
                                        />
                                    </Grid>
                                    {imagem && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "70px",
                                                left: "calc(50% + 110px)",
                                            }}
                                        >
                                            <IconButton size="large" onClick={() => setImagem("")}>
                                                <DeleteForever
                                                    style={{ color: "var(--cor-erro)" }}
                                                    fontSize="large"
                                                />
                                            </IconButton>
                                        </div>
                                    )}

                                    <DialogEscolherOrigemFoto
                                        open={escolhaAberta}
                                        onClose={() => setEscolhaAberta(false)}
                                        onDispositivo={() => {
                                            setEscolhaAberta(false)
                                            handleDivClick()
                                        }}
                                        onGaleria={() => {
                                            setEscolhaAberta(false)
                                            setGaleriaAberta(true)
                                        }}
                                    />

                                    <DialogGaleriaFotos
                                        open={galeriaAberta}
                                        onClose={() => setGaleriaAberta(false)}
                                        onSelect={url => {
                                            setImagem(url)
                                            setGaleriaAberta(false)
                                        }}
                                        idEstabelecimento={estabelecimento?.id}
                                    />

                                    <Grid item xs={12} sm={12} md={12} container spacing={1}>
                                        <Grid item xs={12} sm={4} md={4}>
                                            <TextField
                                                fullWidth
                                                type="text"
                                                variant="outlined"
                                                label="Nome"
                                                placeholder="Ex: X-Tudo"
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={nomeRef}
                                                defaultValue={
                                                    nomeRef?.current?.value ?? modalProduto?.nome
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4}>
                                            <TextField
                                                fullWidth
                                                // type="number"
                                                variant="outlined"
                                                label="Preço"
                                                placeholder="R$ 00,00"
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={valorRef}
                                                defaultValue={modalProduto?.valor}
                                                onChange={handleChange}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4}>
                                            <TextField
                                                fullWidth
                                                type="number"
                                                variant="outlined"
                                                label="Código PDV"
                                                placeholder="Código PDV"
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={codigoRef}
                                                defaultValue={modalProduto?.codigo}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={4}>
                                            <TextField
                                                fullWidth
                                                type="number"
                                                variant="outlined"
                                                label="Posição"
                                                placeholder="999"
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={ordemExibRef}
                                                defaultValue={proximaOrdemExib}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={4}>
                                            <FormControl fullWidth variant="outlined">
                                                <InputLabel>Categoria</InputLabel>
                                                <Select
                                                    label="Categoria"
                                                    value={idCategoria ?? ""}
                                                    onChange={handleChangeIdCategoria}
                                                >
                                                    {categorias.map(categoria => (
                                                        <MenuItem
                                                            key={categoria.id}
                                                            value={categoria.id}
                                                        >
                                                            {categoria.nome}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            container
                                            justifyContent="center"
                                        >
                                            <ToggleButtonGroup fullWidth>
                                                <ToggleButton
                                                    title="Domingo"
                                                    aria-label="Domingo"
                                                    defaultValue={modalProduto?.disponivelDomingo}
                                                    selected={disponivelDomingo}
                                                    onClick={handleChangeDisponivelDomingo}
                                                    className={classes.toggleButton}
                                                >
                                                    D
                                                </ToggleButton>
                                                <ToggleButton
                                                    title="Segunda"
                                                    aria-label="Segunda"
                                                    defaultValue={modalProduto?.disponivelSegunda}
                                                    selected={disponivelSegunda}
                                                    onClick={handleChangeDisponivelSegunda}
                                                    className={classes.toggleButton}
                                                >
                                                    S
                                                </ToggleButton>
                                                <ToggleButton
                                                    title="Terça"
                                                    aria-label="Terça"
                                                    defaultValue={modalProduto?.disponivelTerca}
                                                    selected={disponivelTerca}
                                                    onClick={handleChangeDisponivelTerca}
                                                    className={classes.toggleButton}
                                                >
                                                    T
                                                </ToggleButton>
                                                <ToggleButton
                                                    title="Quarta"
                                                    aria-label="Quarta"
                                                    defaultValue={modalProduto?.disponivelQuarta}
                                                    selected={disponivelQuarta}
                                                    onClick={handleChangeDisponivelQuarta}
                                                    className={classes.toggleButton}
                                                >
                                                    Q
                                                </ToggleButton>
                                                <ToggleButton
                                                    title="Quinta"
                                                    aria-label="Quinta"
                                                    defaultValue={modalProduto?.disponivelQuinta}
                                                    selected={disponivelQuinta}
                                                    onClick={handleChangeDisponivelQuinta}
                                                    className={classes.toggleButton}
                                                >
                                                    Q
                                                </ToggleButton>
                                                <ToggleButton
                                                    title="Sexta"
                                                    aria-label="Sexta"
                                                    defaultValue={modalProduto?.disponivelSexta}
                                                    selected={disponivelSexta}
                                                    onClick={handleChangeDisponivelSexta}
                                                    className={classes.toggleButton}
                                                >
                                                    S
                                                </ToggleButton>
                                                <ToggleButton
                                                    title="Sábado"
                                                    aria-label="Sábado"
                                                    defaultValue={modalProduto?.disponivelSabado}
                                                    selected={disponivelSabado}
                                                    onClick={handleChangeDisponivelSabado}
                                                    className={classes.toggleButton}
                                                >
                                                    S
                                                </ToggleButton>
                                            </ToggleButtonGroup>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={12}>
                                            <TextField
                                                multiline
                                                minRows={3}
                                                fullWidth
                                                variant="outlined"
                                                label="Descrição"
                                                placeholder="Ex: pão macio, hambúrguer suculento, fatias de queijo derretido, presunto, bacon crocante, ovo frito com a gema molinha, alface crocante, tomate fresco, milho verde, ervilha, batata palha, maionese, ketchup e mostarda."
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={descricaoRef}
                                                defaultValue={modalProduto?.descricao}
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={6}
                                            container
                                            alignItems="center"
                                        >
                                            <Checkbox
                                                inputRef={ativoRef}
                                                defaultChecked={
                                                    cadastrar ? true : modalProduto.ativo
                                                }
                                            />
                                            <Typography>Disponível</Typography>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={6}
                                            container
                                            alignItems="center"
                                        >
                                            <Checkbox
                                                inputRef={permiteObservacaoRef}
                                                defaultChecked={
                                                    cadastrar
                                                        ? true
                                                        : modalProduto.permiteObservacao
                                                }
                                            />
                                            <Typography>Permite Observação</Typography>
                                        </Grid>
                                        <CanaisVenda value={canais} onChange={setCanais} />
                                    </Grid>
                                </Grid>
                            </div>
                            <div style={{ display: tela === "ValorPromocional" ? "" : "none" }}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item xs={12} sm={4} md={4}>
                                        <TextField
                                            fullWidth
                                            type="number"
                                            variant="outlined"
                                            label="Domingo"
                                            placeholder="R$ 00,00"
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                                step: "0.01",
                                                inputMode: "decimal",
                                            }}
                                            inputRef={valorDomingoRef}
                                            defaultValue={
                                                modalProduto?.disponibilidadeProduto?.valorDomingo
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={4}>
                                        <TextField
                                            fullWidth
                                            type="number"
                                            variant="outlined"
                                            label="Segunda"
                                            placeholder="R$ 00,00"
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                                step: "0.01",
                                                inputMode: "decimal",
                                            }}
                                            inputRef={valorSegundaRef}
                                            defaultValue={
                                                modalProduto?.disponibilidadeProduto?.valorSegunda
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={4}>
                                        <TextField
                                            fullWidth
                                            type="number"
                                            variant="outlined"
                                            label="Terça"
                                            placeholder="R$ 00,00"
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                                step: "0.01",
                                                inputMode: "decimal",
                                            }}
                                            inputRef={valorTercaRef}
                                            defaultValue={
                                                modalProduto?.disponibilidadeProduto?.valorTerca
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={4}>
                                        <TextField
                                            fullWidth
                                            type="number"
                                            variant="outlined"
                                            label="Quarta"
                                            placeholder="R$ 00,00"
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                                step: "0.01",
                                                inputMode: "decimal",
                                            }}
                                            inputRef={valorQuartaRef}
                                            defaultValue={
                                                modalProduto?.disponibilidadeProduto?.valorQuarta
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={4}>
                                        <TextField
                                            fullWidth
                                            type="number"
                                            variant="outlined"
                                            label="Quinta"
                                            placeholder="R$ 00,00"
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                                step: "0.01",
                                                inputMode: "decimal",
                                            }}
                                            inputRef={valorQuintaRef}
                                            defaultValue={
                                                modalProduto?.disponibilidadeProduto?.valorQuinta
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={4}>
                                        <TextField
                                            fullWidth
                                            type="number"
                                            variant="outlined"
                                            label="Sexta"
                                            placeholder="R$ 00,00"
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                                step: "0.01",
                                                inputMode: "decimal",
                                            }}
                                            inputRef={valorSextaRef}
                                            defaultValue={
                                                modalProduto?.disponibilidadeProduto?.valorSexta
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={4}>
                                        <TextField
                                            fullWidth
                                            type="number"
                                            variant="outlined"
                                            label="Sabado"
                                            placeholder="R$ 00,00"
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                                step: "0.01",
                                                inputMode: "decimal",
                                            }}
                                            inputRef={valorSabadoRef}
                                            defaultValue={
                                                modalProduto?.disponibilidadeProduto?.valorSabado
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            </div>
                            <div style={{ display: tela === "Avançado" ? "" : "none" }}>
                                <Grid container xs={12} sm={12} md={12} spacing={1}>
                                    <Grid item xs={12} sm={12} md={6} container alignItems="center">
                                        <Checkbox
                                            inputRef={apenasPrimeiraCompraRef}
                                            defaultChecked={modalProduto?.apenasPrimeiraCompra}
                                        />
                                        <Typography>Apenas Primeira Compra</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} container alignItems="center">
                                        <Checkbox
                                            inputRef={produtoExibicaoRef}
                                            defaultChecked={modalProduto?.produtoExibicao}
                                        />
                                        <Typography>Produto apenas informativo</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} container alignItems="center">
                                        <Checkbox
                                            inputRef={promocionalRef}
                                            defaultChecked={modalProduto?.promocional}
                                        />
                                        <Typography> Bloquear descontos percentuais</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} container alignItems="center">
                                        <Checkbox
                                            inputRef={pontuarProgramaFidelidadeRef}
                                            defaultChecked={
                                                cadastrar
                                                    ? true
                                                    : modalProduto?.pontuarProgramaFidelidade
                                            }
                                        />
                                        <Typography>Pontua Fidelidade</Typography>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={6}
                                        style={{
                                            marginTop: "1em",
                                            display: "flex",
                                            alignItems: "center",
                                        }}
                                    >
                                        <FormControl
                                            fullWidth
                                            variant="outlined"
                                            disabled={!paramentos.impressaoAlternada}
                                        >
                                            <InputLabel>Impressão Alternada</InputLabel>
                                            <Select
                                                label="Impressão Alternada"
                                                value={impressaoAlternada}
                                                onChange={handleImpressaoAlternada}
                                            >
                                                <MenuItem value={0}> - </MenuItem>
                                                <MenuItem value={1}> 1ª impressora </MenuItem>
                                                <MenuItem value={2}> 2ª impressora </MenuItem>
                                                <MenuItem value={3}> 3ª impressora </MenuItem>
                                                <MenuItem value={4}> 4ª impressora </MenuItem>
                                                <MenuItem value={5}> 5ª impressora </MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={6}
                                        style={{
                                            marginTop: "1em",
                                            display: "flex",
                                            alignItems: "center",
                                        }}
                                    >
                                        <TextField
                                            fullWidth
                                            type="text"
                                            variant="outlined"
                                            label="Pontos"
                                            inputRef={pontosRef}
                                            defaultValue={
                                                pontosRef?.current?.value ?? modalProduto?.pontos
                                            }
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={6}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "0.25em",
                                            marginTop: "1em",
                                        }}
                                    >
                                        <FormControl fullWidth size="small" variant="outlined">
                                            <InputLabel>CFOP</InputLabel>
                                            <Select
                                                label="CFOP"
                                                value={tipoProducao ?? "AUTO"}
                                                onChange={handleTipoProducao}
                                            >
                                                <MenuItem value="AUTO">Automático</MenuItem>
                                                <MenuItem value="5101">
                                                    Produção própria (5101)
                                                </MenuItem>
                                                <MenuItem value="5102">
                                                    Revenda sem ST (5102)
                                                </MenuItem>
                                                <MenuItem value="5405">
                                                    Revenda com ST (5405)
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                        <IconButton
                                            size="small"
                                            aria-label="Recomendações de CFOP"
                                            onClick={e =>
                                                setAnchorRecomendacaoCfop(e.currentTarget)
                                            }
                                        >
                                            <InfoOutlined fontSize="small" />
                                        </IconButton>
                                        <Popover
                                            open={Boolean(anchorRecomendacaoCfop)}
                                                anchorEl={anchorRecomendacaoCfop}
                                                onClose={() => setAnchorRecomendacaoCfop(null)}
                                                anchorOrigin={{
                                                    vertical: "bottom",
                                                    horizontal: "left",
                                                }}
                                                transformOrigin={{
                                                    vertical: "top",
                                                    horizontal: "left",
                                                }}
                                            >
                                                <div style={{ padding: "1em", maxWidth: "360px" }}>
                                                    <Typography
                                                        variant="subtitle2"
                                                        style={{ marginBottom: "0.5em" }}
                                                    >
                                                        Recomendações de CFOP
                                                    </Typography>
                                                    <Typography variant="body2" style={{ marginBottom: "0.5em" }}>
                                                        <strong>Automático:</strong> deixa o sistema
                                                        decidir pelo nome do item (bebida vira revenda;
                                                        os demais, produção própria).
                                                    </Typography>
                                                    <Typography variant="body2" style={{ marginBottom: "0.5em" }}>
                                                        <strong>Produção própria (5101):</strong>{" "}
                                                        produtos preparados ou fabricados pela própria
                                                        loja.
                                                    </Typography>
                                                    <Typography variant="body2" style={{ marginBottom: "0.5em" }}>
                                                        <strong>Revenda sem ST (5102):</strong> produtos
                                                        comprados prontos e revendidos, sem substituição
                                                        tributária.
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        <strong>Revenda com ST (5405):</strong> produtos
                                                        revendidos com substituição tributária (ex.:
                                                        bebidas).
                                                    </Typography>
                                                </div>
                                            </Popover>
                                    </Grid>
                                </Grid>
                            </div>
                        </DialogContent>
                        <DialogActions className={classes.botoes}>
                            <Button
                                onClick={handleCloseProduto}
                                disabled={salvando}
                                className={classes.botaoVoltar}
                            >
                                Voltar
                            </Button>
                            <Button
                                type="submit"
                                disabled={salvando}
                                className={classes.botaoSalvar}
                            >
                                {salvando ? "Salvando..." : "Salvar"}
                            </Button>
                        </DialogActions>
                    </form>
                </Dialog>
            )}
        </>
    )
}
